<script>
import { debounce } from 'lodash'
import LivePreviewIframe from '@/components/preview/LivePreviewIframe'

export default {
  data() {
    return {
      livePreview: true,
      previewContent: null,
      previewContentLoading: false
    }
  },
  computed: {
    previewAvailable() {
      return !!this.previewContent
    }
  },
  methods: {
    fetchPreview: debounce(function() {
      if (!this.livePreview) {
        return
      }
      this.previewContentLoading = true
      this.service
        .preview(this.lookupParams, this.form)
        .then(res => {
          this.$set(this, 'previewContent', res.data)
        })
        .catch(() => {
          this.$set(this, 'previewContent', null)
        })
        .finally(() => {
          this.previewContentLoading = false
        })
    }, 500),
    getPreviewTab() {
      return {
        component: 'el-tab-pane',
        attrs: {
          name: 'preview',
          label: this.previewContentLoading ? 'Podgląd ↻' : 'Podgląd'
        },
        props: {
          disabled: !this.previewAvailable
        },
        children: [
          {
            component: LivePreviewIframe,
            props: {
              previewContent: this.previewContent
            },
            directives: [
              {
                name: 'loading',
                value: this.previewContentLoading
              }
            ],
            listeners: {
              'edit-base': () => {
                this.selectedTab = 'general'
              },
              'move-widget': () => {
                this.selectedTab = 'widgets'
              },
              'add-widget': ({ x, y }) =>
                this.$refs.widgetDialogs.openNewWidgetDialog(y, x),
              'edit-widget': ({ x, y }) => {
                const widgetIndex = this.form.widgets.findIndex(
                  w => w.x === x && w.y === y
                )
                this.$refs.widgetDialogs.editWidget(widgetIndex)
              },
              'remove-widget': ({ x, y }) => {
                const widgetIndex = this.form.widgets.findIndex(
                  w => w.x === x && w.y === y
                )
                this.form.widgets.splice(widgetIndex, 1)
              }
            }
          }
        ]
      }
    }
  }
}
</script>
